import { render, staticRenderFns } from "./ServerVersion.vue?vue&type=template&id=3b19bd70&"
import script from "./ServerVersion.vue?vue&type=script&lang=js&"
export * from "./ServerVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports